export const VERSION_HISTORY_QUERY_KEYS = {
  groupedHistory: "getGroupedVersionHistory"
} as const;

/** Stable React key / expansion-map key for the legacy bucket, whose versionId is null. */
export const UNVERSIONED_ROW_KEY = "unversioned";

export const MAX_VISIBLE_CHANGES = 5;
export const DEFAULT_PAGE_SIZE = 5;
export const PAGE_SIZE_OPTIONS = [5, 10, 25] as const;

/** How many years back the reporting-year picker offers, plus one year ahead. */
export const REPORTING_YEAR_LOOKBACK = 10;

/**
 * Headers for the single shared table: the version bar spans all of these via colSpan, and the
 * calculation-record rows underneath it use them individually. Matches the Lovable prototype's
 * column set (Date / Climate Change Impact / Calculated Version / blank) plus the ticket's added
 * Last Edited By column. Per-version metadata (name, status badges) lives inline in the version
 * bar rather than as its own columns, and the year/units/price details span these same columns
 * in their own row when the version is expanded -- see VersionHistoryRow and VersionDetailsRow.
 */
export const VERSION_HISTORY_COLUMNS = [
  "Date",
  "Climate Change Impact (kgCO2eq/kg)",
  "Calculated Version",
  "Last Edited By",
  ""
] as const;

export const VERSION_HISTORY_COPY = {
  panelTitle: "Mapping Version History",
  panelDescription:
    "View all versions of this mapping, their calculation history, and activate the version you want to use.",
  averageProductMessage: "History not available for the product",
  supplierMessage: "Calculated: Upgrade to see results",
  noVersionHistory: "No version history available",
  versionHistoryLoadError: "Failed to load version history. Please try again.",
  retry: "Retry",
  activeBadge: "Active",
  calculatedBadge: "Calculated",
  notCalculatedBadge: "Not Calculated",
  calculationCountLabel: (count: number) => `${count} calculation${count === 1 ? "" : "s"}`,
  goToMapping: "View Mapping",
  activate: "Activate",
  activateDialogTitle: "Activate version",
  activateConfirm: "Activate version",
  activateDialogBody: (label: string) =>
    `Are you sure you want to activate ${label}? This will replace the current mapping data with this version's data.`,
  activateSuccess: (label: string) => `${label} activated successfully`,
  activateError: "Failed to activate version. Please try again.",
  delete: "Delete",
  deleteTooltip: "Delete version",
  deleteVersionDialogTitle: (label: string) => `Delete ${label}?`,
  deleteVersionConfirm: "Delete version",
  deleteVersionDialogBody:
    "Deleting this version removes all mapping and result data, cost and volume related to it. This data cannot be recovered.",
  deleteVersionActiveNotice: (nextActiveLabel: string) =>
    `This is the active version — ${nextActiveLabel} will be activated automatically.`,
  deleteVersionSuccess: (label: string) => `${label} deleted successfully`,
  renameSuccess: (label: string) => `Version renamed to "${label}"`,
  noCalculationsForVersion: "No calculations performed for this version yet",
  noReasonProvided: "No reason was provided for this version.",
  changedValuesTitle: "Below values were changed",
  noMappingChanges: "No changes were made to the mapping",
  changesUnavailable: "Mapping changes could not be loaded.",
  viewMore: "View more",
  viewLess: "View less",
  details: "Details",
  calculatedVersionPrefix: "EF",
  showingRange: (from: number, to: number, total: number) => `Showing ${from}–${to} of ${total} versions`
} as const;
